module.exports = __webpack_public_path__ + "img/emoji_8.128106b4.png";